export default __webpack_public_path__ + "static/113-8cd3bce15b3e1da2d86f3b4d4fe3e121.gif";